import { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import {
  FaRegCheckCircle as Correct,
  FaRegTimesCircle as Incorrect,
  FaRegCircle,
} from "react-icons/fa";
import WordInput from "./WordInput"; // Import our new component

const TenseInput = ({
  text,
  checkAnswers,
  answer,
  tabIndex,
  disabled = false,
  hintLevel = 0, // Now passed from parent
}) => {
  const [input, setInput] = useState("");

  // When hint level or answer changes, we might need to update our hint
  useEffect(() => {
    // Reset input when answer changes
    if (answer) {
      setInput("");
    }
  }, [answer]);

  const checkAnswer = (user, userAnswer) => {
    if (user && answer) {
      return user.toLowerCase().trim() === userAnswer.toLowerCase();
    }
    return false;
  };

  const validationIcon = (show, correct) => {
    if (show) {
      return correct ? <Correct color="green" /> : <Incorrect color="red" />;
    }
    return <FaRegCircle color={"gainsboro"} />;
  };

  // Generate hint based on the current hint level
  const generateHint = () => {
    if (!answer) return null;

    switch (hintLevel) {
      case 0: // No hint
        return null;

      case 1: // First level: Show last letter
        return Array(answer.length)
          .fill("_")
          .map((_, index) => {
            // Show the last letter
            if (index === answer.length - 1) {
              return answer[index];
            }
            return "_";
          })
          .join("");

      case 2: // Second level: Show 75% of word
        const revealCount = Math.ceil(answer.length * 0.75);

        return Array(answer.length)
          .fill("_")
          .map((_, index) => {
            // For 75% reveal: show letters up to revealCount, always include last letter
            if (index === answer.length - 1 || index < revealCount - 1) {
              return answer[index];
            }
            return "_";
          })
          .join("");

      case 3: // Study mode: Show entire word
        return answer; // Full word as hint

      default:
        return null;
    }
  };

  const handleChange = (newInput) => {
    setInput(newInput);
  };

  const handleComplete = (isCorrect) => {
    // This would be called when the user completes the word
    // You could add additional logic here if needed
  };

  const isStudyMode = hintLevel === 3;

  return (
    <>
      <Grid item xs={1}>
        {!isStudyMode &&
          validationIcon(checkAnswers, checkAnswer(input, answer))}
      </Grid>
      <Grid item xs={5}>
        {hintLevel === 0 ? (
          <TextField
            disabled={disabled || isStudyMode} // Disable input in study mode
            error={!isStudyMode && checkAnswers && !checkAnswer(input, answer)}
            helperText={disabled ? "-" : text}
            label={checkAnswers ? answer : " "}
            value={hintLevel > 0 ? getDisplayValue() : undefined}
            onChange={(e) => setInput(e.target.value)}
            inputProps={{
              spellCheck: false,
              tabIndex: isStudyMode ? -1 : tabIndex,
            }}
            margin="normal"
          />
        ) : (
          <WordInput
            word={answer || ""}
            hint={generateHint()}
            onChange={handleChange}
            onComplete={handleComplete}
            disabled={disabled || isStudyMode} // Disable input in study mode
            tabIndex={isStudyMode ? -1 : tabIndex} // Remove from tab order in study mode
            error={!isStudyMode && checkAnswers && !checkAnswer(input, answer)}
            helperText={disabled ? "-" : text}
            isStudyMode={isStudyMode} // Flag to indicate study mode
          />
        )}
        {checkAnswers && (
          <div
            style={{
              fontSize: "0.75rem",
              color: "#3f51b5",
              marginTop: "4px",
            }}
          >
            {answer}
          </div>
        )}
      </Grid>
    </>
  );
};

export default TenseInput;
